import fetcher from '../API';
const debit = {
    "cents": -1,
    "charged": 7118,
    "refunded": 0
}
const orderSource = "FBB_PROCUREMENT"
const constantData = {
    "includedInOrder": 0,
    "shippingCostCents": 10000,
    "taxCents": 10000,
    "dutyCents": 0,
    "prepaidDutyCents": 0,
    "dutyRebateCents": 0,
    "overflownDutyRebateCents": 0,
    "shippingMethodOptions": [{
        "name": "MERCHANT_DIRECT",
        "label": "商家直邮",
        "note": "仅限美国境内运输,通常3-5天",
        "costValue": "$0"
    }],
    "shippingMethod": "MERCHANT_DIRECT",
    "paymentMethodOptions": [{
        "name": "DEBIT"
    }],
    "paymentMethod": "DEBIT"
}
const getSku = (cents, skuInfo, productInfo) => {
    return {
        "id": skuInfo['id'],
        "merchantId": productInfo['merchantId'],
        "productId": productInfo['id'],
        "name": productInfo['name'],
        "brand": productInfo['name'],
        "brandId": productInfo['brandId'],
        "officialURL": productInfo['officialURL'],
        "cents": cents,
        "originalCents": skuInfo['originalCents'],
        "onHand": skuInfo['onHand'],
        "color": skuInfo['color'],
        "size": skuInfo['size'],
        "mid": skuInfo['mid'] === undefined ? null : skuInfo['mid'],
        "attributes": skuInfo['attributes'] === undefined ? {} : skuInfo['attributes'],
        "images": skuInfo['images'] === undefined ? [] : skuInfo['images']
    }
}
const getMerchantValue = (cents, quantity) => {
    return ([...new Array(quantity)].map(_ => cents))
}
export const submitOrder = (orderItemId, cents, quantity, skuInfo, productInfo, count, groupInfo = {}) => {
    const param = {
        "cart": {
            "groups": [{
                "id": productInfo['merchantId'],
                "items": [{
                    "id": orderItemId,
                    "sku": getSku(cents, skuInfo, productInfo),
                    "quantity": quantity,
                    "cents": cents * quantity,
                    "originalCents": skuInfo['originalCents'] * quantity,
                    "merchantValue": getMerchantValue(cents, quantity),
                    "initialUnitCents": cents,
                    "dutyDetail": {
                        "dutyCost": 0,
                        "declaredValue": cents,
                        "tariffCost": 0,
                        "taxCost": 0
                    },
                    "finalCents": 0,
                    "availability": "AVAILABLE",
                    "categoryIds": productInfo['categoryIds'],
                    "tags": [
                        "AVAILABLE"
                    ]
                }],
                ...constantData,
                ...groupInfo
            }]
        },
        debit,
        orderSource
    }
    return fetcher.post(`api/v1/orders-express`, param)
}